module.exports = {
	recorridoData: () => {
		return [
			{
				START: {
					Image: require('./../assets/recorridoComerciales/General_01.webp'),
					Rotation: '0 0 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '4.044 -0.129 -0.710',
							Rotation: '-90 10 0',
							Scale: '0.2 0.2',
							goTo: 'STARIA',
						},
						{
							Position: '-0.2 0.038 -5.011',
							Rotation: '-90 10 0',
							Scale: '0.2 0.2',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '10.805 -3.006 14.096',
							Rotation: '-90 10 0',
							Scale: '0.6 0.6',
							goTo: 'EX8',
						},
						{
							Position: '-4.412 -2.973 17.694',
							Rotation: '-90 10 0',
							Scale: '0.6 0.6',
							goTo: 'EX10',
						},
					],
					BulletsInfo: [],
				},
				STARIA: {
					Image: require('./../assets/recorridoComerciales/StariaServicioPublico_Frente.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '3.519 -0.129 0.878',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '5.033 -0.129 -9.305',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'EX10',
						},
						{
							Position: '-3.5 -1.472 -13.148',
							Rotation: '-90 10 0',
							Scale: '0.6 0.6',
							goTo: 'EX8',
						},
						{
							Position: '5.406 -1.049 8.218',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '-2.791 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.403',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA LAT IZQ',
						},
						{
							Position: '-5,384 -0.129 3.061',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.761 -1.494',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Luces frontales halógenas + DRL',
						},
					],
				},
				'STARIA DIG IZQ': {
					Image: require('./../assets/recorridoComerciales/StariaServicioPublico_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '-0.065 -0.129 6.367',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '19.518 -0.129 -1.989',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX10',
						},
						{
							Position: '16.306 -0.129 -5.219',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX8',
						},
						{
							Position: '11.251 -0.129 -6.007',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'HD78',
						},
						{
							Position: '6.481 -0.129 -7.034',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'HD65',
						},
						{
							Position: '3.175 -0.129 -3.862',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'HD55',
						},
						{
							Position: '-7.783 -0.129 6.367',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '-8.703 -0.129 12.272',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'SUPER METRO ACCENT',
						},
						{
							Position: '-7.053 -0.129 17.285',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO HB',
						},
						{
							Position: '-1.876 -0.129 18.147',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO SEDAN',
						},
						{
							Position: '-3.386 -0.129 2.688',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA',
						},
						{
							Position: '-4.264 -0.129 -3.073',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA LAT IZQ',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.181 -0.443',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Llantas de acero de 17"',
						},
					],
				},
				'STARIA LAT IZQ': {
					Image: require('./../assets/recorridoComerciales/StariaServicioPublico_LateralIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '-2.535 -0.129 8.559',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '-5.320 -0.295 5.727',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA',
						},
						{
							Position: '-2.572 -0.129 3.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA DIG IZQ',
						},
						{
							Position: '-2.779 -0.129 -4.237',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA POSTERIOR',
						},
						{
							Position: '3.064 -0.129 4.399',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8',
						},
						{
							Position: '5.554 -0.129 0.129',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 LAT DER',
						},
						{
							Position: '3.959 -0.129 10.812',
							Rotation: '-82.68 -148.74 -176.93',
							Scale: '0.3 0.3',
							goTo: 'EX10',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.175 2.661',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Llantas de acero de 17"',
						},
					],
				},
				'STARIA LAT DER': {
					Image: require('./../assets/recorridoComerciales/StariaServicioPublico_LateralDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '-3.445 -0.129 -10.851',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '2.081 -0.154 -9.404',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI',
						},

						{
							Position: '-4.148 -0.129 -5.739',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA',
						},
						{
							Position: '-2.500 -0.129 4.059',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA DIG DER',
						},
						{
							Position: '-4.268 -0.025 6.294',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.021 -3.281',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Llantas de acero de 17"',
						},
					],
				},
				'STARIA DIG DER': {
					Image: require('./../assets/recorridoComerciales/StariaServicioPublico_DiagonalDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-7.473 -0.129 -11.253',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '-3.159 -0.129 2.721',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA POSTERIOR',
						},
						{
							Position: '-1.576 0.870 -1.236',
							Rotation: '-90 0 0',
							Scale: '0.2 0.2',
							goTo: 'STARIA LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.181 -0.667',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Llantas de acero de 17"',
						},
					],
				},
				'STARIA POSTERIOR': {
					Image: require('./../assets/recorridoComerciales/StariaServicioPublico_Posterior.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-2.642 -0.129 -1.775',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA DIG DER',
						},
						{
							Position: '-5.370 -0.129 2.793',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA LAT IZQ',
						},
						{
							Position: '-4.991 -0.129 -2.625',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'STARIA LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.674 0.019',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Espacio de carga de la camioneta de 2 plazas con panel',
						},
						{
							Position: '-3.826 1.712 -1.013',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Puertas batientes gemelas (Únicamente versión Staria Panel)',
						},
					],
				},

				EX8: {
					Image: require('./../assets/recorridoComerciales/EX8_Frente.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '6.625 -0.129 -0.445',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '0.108 -0.129 -6.841',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX10',
						},
						{
							Position: '4.642 -0.129 4.386',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'STARIA',
						},
						{
							Position: '-0.630 -0.129 6.239',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'STARIA LAT IZQ',
						},
						{
							Position: '-3.617 -0.129 -1.928',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 DIG IZQ',
						},
						{
							Position: '-6.981 -0.129 -3.102',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX8 LAT IZQ',
						},
						{
							Position: '-6.981 -0.129 3.543',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX8 LAT DER',
						},
					],
					BulletsInfo: [],
				},
				'EX8 DIG IZQ': {
					Image: require('./../assets/recorridoComerciales/EX8_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '1.119 -0.129 7.136',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '3.751 -0.129 0.191',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX10',
						},
						{
							Position: '-4.278 -0.129 7.939',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'HD78',
						},
						{
							Position: '-1.404 -0.129 2.165',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8',
						},
						{
							Position: '-4.264 -0.129 -3.073',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 LAT IZQ',
						},
					],
					BulletsInfo: [],
				},
				'EX8 LAT IZQ': {
					Image: require('./../assets/recorridoComerciales/EX8_LateralIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '1.432 -0.129 7.144',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10',
						},
						{
							Position: '-4.928 -0.129 5.817',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX8',
						},
						{
							Position: '-2.704 -0.129 3.706',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX8 DIG IZQ',
						},
						{
							Position: '-3.999 -0.129 -5.403',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX8 POSTERIOR',
						},
					],
					BulletsInfo: [],
				},
				'EX8 LAT DER': {
					Image: require('./../assets/recorridoComerciales/EX8_LateralDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '1.750 -0.129 -6.719',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'STARIA LAT IZQ',
						},
						{
							Position: '-1.556 -0.129 -12.313',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'STARIA',
						},
						{
							Position: '-4.148 -0.129 -5.287',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX8',
						},
						{
							Position: '-2.416 -0.129 4.214',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 DIG DER',
						},
						{
							Position: '-6.314 -0.675 7.089',
							Rotation: '-86.68 180 180',
							Scale: '0.4 0.4',
							goTo: 'EX8 POSTERIOR',
						},
					],
					BulletsInfo: [],
				},
				'EX8 DIG DER': {
					Image: require('./../assets/recorridoComerciales/EX8_DiagonalDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-3.159 -0.129 2.721',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 POSTERIOR',
						},
						{
							Position: '-4.613 -0.129 -2.826',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 LAT DER',
						},
					],
					BulletsInfo: [],
				},
				'EX8 POSTERIOR': {
					Image: require('./../assets/recorridoComerciales/EX8_Posterior.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-3.376 -0.129 -1.589',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 DIG DER',
						},
						{
							Position: '-8.005 -0.129 3.121',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 LAT IZQ',
						},
						{
							Position: '-8.008 -0.129 -2.979',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 LAT DER',
						},
					],
					BulletsInfo: [],
				},

				EX10: {
					Image: require('./../assets/recorridoComerciales/EX10_Frente.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '5.780 -0.129 0.568',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '1.124 -0.129 6.324',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX8',
						},
						{
							Position: '-3.401 -0.129 7.812',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX8 LAT IZQ',
						},
						{
							Position: '-3.109 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 DIG IZQ',
						},
						{
							Position: '-5.918 -0.129 -3.378',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10 LAT IZQ',
						},
						{
							Position: '-6.238 -0.129 2.968',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10 LAT DER',
						},
					],
					BulletsInfo: [],
				},
				'EX10 DIG IZQ': {
					Image: require('./../assets/recorridoComerciales/EX10_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '3.928 -0.129 7.274',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '-2.591 -0.129 8.173',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX8',
						},
						{
							Position: '-1.404 -0.129 2.165',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10',
						},
						{
							Position: '-4.264 -0.129 -3.073',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 LAT IZQ',
						},
					],
					BulletsInfo: [],
				},
				'EX10 LAT IZQ': {
					Image: require('./../assets/recorridoComerciales/EX10_LateralIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-5.977 -0.528 6.697',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10',
						},
						{
							Position: '-1.975 -0.129 3.579',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10 DIG IZQ',
						},
						{
							Position: '-4.413 -0.129 -5.777',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10 POSTERIOR',
						},
					],
					BulletsInfo: [],
				},
				'EX10 LAT DER': {
					Image: require('./../assets/recorridoComerciales/EX10_LateralDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '0.935 -0.129 -8.706',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'EX8',
						},
						{
							Position: '-4.832 -0.129 -5.592',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10',
						},
						{
							Position: '-1.943 -0.129 4.253',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10 DIG DER',
						},
						{
							Position: '-4.622 -0.129 6.548',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EX10 POSTERIOR',
						},
					],
					BulletsInfo: [],
				},
				'EX10 DIG DER': {
					Image: require('./../assets/recorridoComerciales/EX10_DiagonalDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-3.159 -0.129 2.721',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 POSTERIOR',
						},
						{
							Position: '-4.613 -0.129 -2.826',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 LAT DER',
						},
						{
							Position: '-3.446 -0.129 -9.125',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX8 LAT IZQ',
						},
					],
					BulletsInfo: [],
				},
				'EX10 POSTERIOR': {
					Image: require('./../assets/recorridoComerciales/EX10_Posterior.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-4.037 -0.129 -1.420',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 DIG DER',
						},
						{
							Position: '-7.195 -0.129 2.818',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 LAT IZQ',
						},
						{
							Position: '-8.008 -0.129 -2.570',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EX10 LAT DER',
						},
					],
					BulletsInfo: [],
				},

				'GRAND METRO TAXI': {
					Image: require('./../assets/recorridoComerciales/GrandMetroTaxi_Frente.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '4.032 -0.129 2.491',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '5,010 -0.129 -4.039',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'STARIA',
						},
						{
							Position: '-2.339 -0.129 -1.285',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI LAT IZQ',
						},
						{
							Position: '-5.522 -0.129 2.764',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI LAT DER',
						},
					],
					BulletsInfo: [],
				},
				'GRAND METRO TAXI DIG IZQ': {
					Image: require('./../assets/recorridoComerciales/GrandMetroTaxi_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '2.225 -0.129 7.212',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '5.296 -0.129 3.590',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'STARIA',
						},
						{
							Position: '-2.122 -0.129 1.417',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '-3.394 -0.129 -2.392',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI LAT IZQ',
						},
					],
					BulletsInfo: [],
				},
				'GRAND METRO TAXI LAT IZQ': {
					Image: require('./../assets/recorridoComerciales/GrandMetroTaxi_LateralIzq.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '-3.628 -0.129 11.597',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '-4.148 -0.129 4.408',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '-1.668 -0.129 2.441',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI DIG IZQ',
						},
						{
							Position: '-3.708 -0.129 -4.554',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI POSTERIOR',
						},
					],
					BulletsInfo: [],
				},
				'GRAND METRO TAXI LAT DER': {
					Image: require('./../assets/recorridoComerciales/GrandMetroTaxi_LateralDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '-1.539 -0.129 -10.786',
							Rotation: '-90 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '2.912 -0.129 -2.796',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'SUPER METRO ACCENT',
						},
						{
							Position: '8.207 -0.129 -7.537',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO SEDAN',
						},
						{
							Position: '-8.256 -0.129 -11.741',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'STARIA',
						},
						{
							Position: '-4.148 -0.129 -4.909',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI',
						},
						{
							Position: '-1.668 -0.129 2.441',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI DIG DER',
						},
						{
							Position: '-3.708 -0.129 3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GRAND METRO TAXI POSTERIOR',
						},
					],
					BulletsInfo: [],
				},
				'GRAND METRO TAXI DIG DER': {
					Image: require('./../assets/recorridoComerciales/GrandMetroTaxi_DiagonalDer.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [
						{
							Position: '-7.494 -0.129 -9.638',
							Rotation: '-90 10 0',
							Scale: '0.6 0.6',
							goTo: 'START',
						},
					],
					HotspotIndividual: [
						{
							Position: '-2.256 -0.129 -7.581',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'SUPER METRO ACCENT',
						},
						{
							Position: '-2.301 -0.129 1.198',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI POSTERIOR',
						},
						{
							Position: '-3.459 -0.129 -2.150',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI LAT DER',
						},
					],
					BulletsInfo: [],
				},
				'GRAND METRO TAXI POSTERIOR': {
					Image: require('./../assets/recorridoComerciales/GrandMetroTaxi_Posterior.webp'),
					Rotation: '0 90 0',
					HotspotFamilias: [],
					HotspotDesplazamiento: [],
					HotspotIndividual: [
						{
							Position: '-7.515 -0.129 -7.045',
							Rotation: '-90 10 0',
							Scale: '0.5 0.5',
							goTo: 'SUPER METRO ACCENT',
						},
						{
							Position: '-1.642 -0.129 -1.354',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI DIG DER',
						},
						{
							Position: '-4.503 -0.129 2.876',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI LAT IZQ',
						},
						{
							Position: '-4.239 -0.129 -2.856',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'GRAND METRO TAXI LAT DER',
						},
						{
							Position: '-11.645 -0.129 -11.754',
							Rotation: '-89.990 114.538 -114.404',
							Scale: '0.5 0.5',
							goTo: 'GRAND METRO SEDAN',
						},
					],
					BulletsInfo: [],
				},
			},
		];
	},
};
